{
  "el": {
    "milestone": {
      "actions": {
        "activate": "Ενεργοποίηση",
        "activate_phase": "Ενεργοποίηση αυτής της φάσης",
        "complete_phase": "Ολοκλήρωση αυτής της φάσης",
        "create": "Δημιουργία φάσης",
        "delete": "Διαγραφή",
        "delete_milestones": "Διαγραφή φάσης | Διαγραφή {count} φάσεων",
        "move_down": "Μετακίνηση φάσης κάτω",
        "move_unit_back": "Επαναφορά ακινήτου εδώ",
        "move_up": "Μετακίνηση φάσης πάνω",
        "new": "Φάση",
        "reactivate_phase": "Επανενεργοποίηση αυτής της φάσης"
      },
      "activate": {
        "body": "Όλα τα στοιχεία αυτής της φάσης δημοσιεύονται για αυτή τη μονάδα και οι αρμόδιοι λαμβάνουν ειδοποίηση.",
        "body_empty": "Δεν καθιστά τίποτα ορατό στον πελάτη.",
        "body_intermediate": "Οι ενδιάμεσες φάσεις ολοκληρώνονται επίσης και όλα τα στοιχεία που συνδέονται με αυτές δημοσιεύονται κι αυτά.",
        "body_project": "Όλα τα στοιχεία αυτής της φάσης δημοσιεύονται για αυτό το έργο και οι αρμόδιοι λαμβάνουν ειδοποίηση.",
        "body_reactivate": "Αυτή η φάση γίνεται ξανά η τρέχουσα. Δεν ανακαλείται τίποτα: ό,τι έχει ήδη δημοσιευτεί ή σταλεί παραμένει. Οι επόμενες φάσεις γίνονται ξανά προγραμματισμένες.",
        "confirm": "Ενεργοποίηση",
        "confirm_publish": "Ενεργοποίηση και αποστολή",
        "confirm_reactivate": "Επανενεργοποίηση",
        "past_warning": "Η επιστροφή σε προηγούμενη φάση δεν αναιρεί όσα έχουν ήδη γίνει. Ό,τι έχει κοινοποιηθεί στους πελάτες δεν ανακαλείται αυτόματα.",
        "title": "Ενεργοποίηση φάσης",
        "title_activate": "Ενεργοποίηση του “{name}”;",
        "title_reactivate": "Επανενεργοποίηση του “{name}”;",
        "verb_default": "ξεκινήσει",
        "verb_share": "κοινοποιήσει"
      },
      "assign": {
        "body": "Τα ακίνητα που επιλέγεις μετακινούνται στο «{to}». Τα στοιχεία του «{to}» και κάθε φάσης που παραλείπουν γίνονται ορατά στον πελάτη και οι ανατεθειμένοι λαμβάνουν ειδοποίηση.",
        "body_phases_only": "Τα ακίνητα που επιλέγεις μετακινούνται στο «{to}». Ο πελάτης βλέπει τη νέα φάση.",
        "excluded": "Δεν μπορείς να επιλέξεις ακίνητα που είναι ήδη στο «{to}» ή πιο μετά."
      },
      "attach": {
        "add": "Προσθήκη",
        "add_and_move": "Προσθήκη και μετακίνηση",
        "assigned_tag": "Ανατεθειμένο",
        "back": "Πίσω",
        "counts": "{available} διαθέσιμα · {assigned} ήδη ανατεθειμένα",
        "description_decision": "Επιλογές που πρέπει να κάνει ο πελάτης",
        "description_survey": "Ερωτηματολόγια για τη συλλογή απαντήσεων",
        "description_todo": "Εργασίες που πρέπει να ολοκληρώσει ο πελάτης",
        "elsewhere_tag": "Τώρα στη φάση {name}",
        "empty": "Δεν υπάρχουν διαθέσιμα στοιχεία",
        "empty_state_description": "Με βάση το πλάνο σου μπορείς να προσθέσεις σε αυτή τη φάση: {kinds}.",
        "intro": "Διάλεξε τον τύπο στοιχείου που θέλεις να συνδέσεις με αυτή τη φάση.",
        "move_notice_body": "Ό,τι έχει ήδη σταλεί παραμένει. Η προηγούμενη φάση χάνει αυτό το στοιχείο.",
        "move_notice_item": "{element}, τώρα στη φάση {phase}",
        "move_notice_title": "Αυτό το στοιχείο μετακινείται στη φάση «{name}» | Αυτά τα στοιχεία μετακινούνται στη φάση «{name}»",
        "next": "Επόμενο",
        "search": "Αναζήτηση",
        "select_intro": "Επίλεξε τι θέλεις να προσθέσεις: {kind}.",
        "subtitle": "Στη φάση: {name}",
        "success": "Τα στοιχεία προστέθηκαν",
        "title": "Προσθήκη στοιχείων"
      },
      "complete_phase": {
        "body": "Αυτό το ακίνητο ολοκληρώνει αυτή τη φάση και μένει χωρίς ενεργή φάση. | {count} ακίνητα ολοκληρώνουν αυτή τη φάση και μένουν χωρίς ενεργή φάση.",
        "body_sup": "Αυτό το έργο ολοκληρώνει αυτή τη φάση και μένει χωρίς ενεργή φάση.",
        "confirm": "Ολοκλήρωση φάσης",
        "keep": "Διατήρηση ενεργής φάσης",
        "title": "Ολοκλήρωση της φάσης “{name}”;"
      },
      "delete_phase": {
        "body": "Τα ακίνητα που βρίσκονται τώρα σε αυτήν τη φάση μένουν χωρίς ενεργή φάση. Δεν μεταφέρονται στο προηγούμενο ή στο επόμενο βήμα. Τα στοιχεία αυτής της φάσης αποσυνδέονται, δεν διαγράφονται. Τα στοιχεία που έχουν ήδη δημοσιευτεί σε ένα ακίνητο παραμένουν δημοσιευμένα: αυτά τα διαγράφεις στο ίδιο το ακίνητο.",
        "body_last": "Τα ακίνητα που βρίσκονται τώρα σε αυτήν τη φάση μένουν χωρίς ενεργή φάση. Επειδή αυτή είναι η τελευταία φάση, θεωρούνται στη συνέχεια ολοκληρωμένα. Τα στοιχεία αυτής της φάσης αποσυνδέονται, δεν διαγράφονται. Τα στοιχεία που έχουν ήδη δημοσιευτεί σε ένα ακίνητο παραμένουν δημοσιευμένα: αυτά τα διαγράφεις στο ίδιο το ακίνητο.",
        "body_sup": "Αυτό το έργο μένει χωρίς ενεργή φάση. Δεν μεταφέρεται στο προηγούμενο ή στο επόμενο βήμα. Τα στοιχεία αυτής της φάσης αποσυνδέονται, δεν διαγράφονται. Τα στοιχεία που έχουν ήδη δημοσιευτεί παραμένουν δημοσιευμένα: αυτά τα διαγράφεις στο ίδιο το έργο.",
        "confirm": "Διαγραφή φάσης",
        "keep": "Διατήρηση φάσης",
        "title": "Διαγραφή της φάσης «{name}»;"
      },
      "detach": {
        "body": "Αυτό αφαιρεί το στοιχείο από αυτή τη φάση. Το ίδιο το στοιχείο εξακολουθεί να υπάρχει και τα ακίνητα που το είδαν ήδη το διατηρούν. Τα νέα ακίνητα δεν το λαμβάνουν πλέον σε αυτή τη φάση.",
        "confirm": "Αποσύνδεση",
        "keep": "Διατήρηση",
        "title": "Αποσύνδεση του «{name}»;"
      },
      "filters": {
        "clear": "Καθαρισμός όλων των φίλτρων",
        "done": "Έτοιμο",
        "group_milestones": "Φάσεις",
        "group_status": "Κατάσταση",
        "group_title": "Περιεχόμενο φάσης",
        "no_phase": "Καμία φάση",
        "no_units_here": "Κανένα ακίνητο εδώ",
        "nothing_assigned": "Τίποτα δεν έχει ανατεθεί",
        "phase_last": "Στην τελευταία φάση",
        "since_month_over": "Περισσότερο από έναν μήνα",
        "since_quarter_over": "Περισσότερο από 3 μήνες",
        "since_two_weeks_over": "Περισσότερο από 2 εβδομάδες",
        "title": "Φίλτρα",
        "units_here": "Έχει ακίνητα εδώ"
      },
      "labels": {
        "add_element": "Προσθήκη στοιχείου",
        "added_ago": "Προστέθηκε πριν από {duration}",
        "assign_units": "Ανάθεση ακινήτων",
        "assigned_count": "0 ανατεθειμένα | 1 ανατεθειμένο | {count} ανατεθειμένα",
        "assigned_elements": "Ανατεθειμένα στοιχεία",
        "assigned_empty_description": "Σύνδεσε με αυτή τη φάση: {kinds}",
        "assigned_empty_title": "Κανένα στοιχείο ακόμη",
        "bulk_assign_title": "Επίλεξε τα ακίνητα στα οποία θέλεις να ανατεθεί η φάση «{milestone_name}»",
        "complete_units": "Ολοκλήρωση {count} ακινήτου | Ολοκλήρωση {count} ακινήτων",
        "completed_subtitle": "Αυτά τα ακίνητα ολοκλήρωσαν τη ροή εργασίας",
        "completed_title": "Ολοκληρώθηκε",
        "detach": "Αποσύνδεση",
        "detach_element": "Αποσύνδεση {name}",
        "drag_to_reorder": "Σύρετε για αναδιάταξη",
        "edit_milestone": "Επεξεργασία φάσης",
        "element_count": "{count} στοιχείο | {count} στοιχεία",
        "elements_assign_link": "Αναθέστε στοιχεία στα Ορόσημα",
        "elements_empty": "Δεν έχουν ανατεθεί ακόμη στοιχεία σε αυτή τη φάση.",
        "elements_visible": "Ορατά στον πελάτη: {elements}",
        "empty_state_subtitle": "Οι φάσεις κάνουν την πορεία της κατασκευής πιο διαφανή για τους αγοραστές",
        "empty_state_title": "Δημιούργησε μια νέα φάση",
        "kind_decision": "Απόφαση | Αποφάσεις",
        "kind_decision_count": "{count} επιλογή | {count} επιλογές",
        "kind_survey": "Ερωτηματολόγιο | Ερωτηματολόγια",
        "kind_survey_count": "{count} ερωτηματολόγιο | {count} ερωτηματολόγια",
        "kind_todo": "Εργασία | Εργασίες",
        "kind_todo_count": "{count} εργασία | {count} εργασίες",
        "locked_not_sent": "{count} στοιχείο είναι κλειδωμένο από το πακέτο σου και δεν θα γίνει αποστολή. | {count} στοιχεία είναι κλειδωμένα από το πακέτο σου και δεν θα γίνει αποστολή.",
        "locked_tooltip": "Δεν περιλαμβάνεται στο τρέχον πακέτο σου. Δεν θα γίνει αποστολή στους πελάτες.",
        "milestone": "Φάση",
        "milestone_current": "Τρέχουσα φάση",
        "milestone_name": "Όνομα φάσης",
        "move_units_to": "Μετακίνηση {count} ακινήτου στο {name} | Μετακίνηση {count} ακινήτων στο {name}",
        "new_milestone": "Νέα φάση",
        "no_phase": "Χωρίς φάση",
        "no_results": "Δεν βρέθηκαν φάσεις",
        "please_select": "Επίλεξε μια νέα φάση",
        "position": "Θέση",
        "progress": "Πρόοδος",
        "publishes_empty": "Δεν έχει ανατεθεί τίποτα ακόμη",
        "publishes_summary": "Κάνει {elements} ορατά στον πελάτη",
        "reorder_filtered": "Καθάρισε την αναζήτηση ή το φίλτρο για να αναδιατάξεις τις φάσεις",
        "search_empty_state": "Δεν έχουν δημιουργηθεί ακόμη φάσεις. Κάνε κλικ εδώ για να ξεκινήσεις",
        "search_phase": "Αναζήτηση φάσης",
        "search_unit": "Αναζήτηση ακινήτου",
        "search_units": "Αναζήτηση ακινήτων",
        "since": "Από",
        "started_on": "Ξεκίνησε {date}",
        "status_active": "Σε εξέλιξη",
        "status_completed": "Ολοκληρωμένη",
        "status_planned": "Προγραμματισμένη",
        "unit_active_since": "Σε εξέλιξη από {date}",
        "unit_completed_on": "Ολοκληρώθηκε {date}",
        "unit_timeline_empty": "Δεν έχουν δημιουργηθεί ακόμη φάσεις για αυτό το έργο.",
        "units": "Ακίνητα",
        "units_completed": "Κανένα ακίνητο δεν ολοκληρώθηκε | 1 ακίνητο ολοκληρώθηκε | {count} ακίνητα ολοκληρώθηκαν",
        "units_empty": "Κανένα ακίνητο δεν έχει φτάσει ακόμη σε αυτή τη φάση.",
        "units_here": "Κανένα ακίνητο εδώ | 1 ακίνητο εδώ | {count} ακίνητα εδώ",
        "units_no_results": "Δεν βρέθηκαν ακίνητα",
        "units_without_milestone": "1 ακίνητο χωρίς φάση | {count} ακίνητα χωρίς φάση",
        "unstarted_subtitle": "Αυτά τα ακίνητα δεν έχουν ενεργή φάση",
        "unstarted_title": "Εκτός φάσης",
        "warning_delete": "Αν διαγράψεις μια φάση που έχει ανατεθεί σε ακίνητο, ο πελάτης δεν θα βλέπει πια σε ποια φάση βρίσκεται το ακίνητό του. Φρόντισε να αναθέσεις νέα φάση σε αυτά τα ακίνητα."
      },
      "move": {
        "body": "Αυτό το ακίνητο μετακινείται από «{from}» στο «{to}». Τα στοιχεία του «{to}» γίνονται ορατά στον πελάτη και οι ανατεθειμένοι λαμβάνουν ειδοποίηση. | Αυτά τα ακίνητα μετακινούνται από «{from}» στο «{to}». Τα στοιχεία του «{to}» γίνονται ορατά στον πελάτη και οι ανατεθειμένοι λαμβάνουν ειδοποίηση.",
        "body_phases_only": "Αυτό το ακίνητο μετακινείται από «{from}» στο «{to}». Ο πελάτης βλέπει τη νέα φάση. | Αυτά τα ακίνητα μετακινούνται από «{from}» στο «{to}». Ο πελάτης βλέπει τη νέα φάση.",
        "confirm": "Μετακίνηση και ειδοποίηση",
        "confirm_phases_only": "Μετακίνηση",
        "elements": "Καθιστά ορατό {elements} στον πελάτη",
        "elements_empty": "Δεν καθιστά τίποτα ορατό στον πελάτη",
        "title": "Μετακίνηση {count} ακινήτου στο «{name}»; | Μετακίνηση {count} ακινήτων στο «{name}»;"
      },
      "overview": {
        "no_phase": "Καμία φάση",
        "not_started": "Δεν ξεκίνησε",
        "since_date": "Από {date}",
        "step_of": "Βήμα {step} από {total}"
      },
      "publication_failed": {
        "body": "Η αποστολή των στοιχείων αυτής της φάσης απέτυχε για 1 ακίνητο. | Η αποστολή των στοιχείων αυτής της φάσης απέτυχε για {count} ακίνητα.",
        "retried": "Τα στοιχεία αποστέλλονται ξανά",
        "retry": "Επαναποστολή"
      },
      "reorder": {
        "body_earlier": "Η μετακίνηση αυτής της φάσης νωρίτερα δεν αποσύρει τίποτα από όσα έχουν ήδη δημοσιευτεί. Τα ακίνητα κρατούν ό,τι έχουν· αλλάζει μόνο η σειρά.",
        "body_earlier_sup": "Η μετακίνηση αυτής της φάσης νωρίτερα δεν αποσύρει τίποτα από όσα έχουν ήδη δημοσιευτεί. Το έργο κρατά ό,τι έχει· αλλάζει μόνο η σειρά.",
        "body_later": "Η μετακίνηση αυτής της φάσης αργότερα δεν αποσύρει τίποτα από όσα έχουν ήδη δημοσιευτεί. Τα ακίνητα κρατούν ό,τι έχουν· αλλάζει μόνο η σειρά.",
        "body_later_sup": "Η μετακίνηση αυτής της φάσης αργότερα δεν αποσύρει τίποτα από όσα έχουν ήδη δημοσιευτεί. Το έργο κρατά ό,τι έχει· αλλάζει μόνο η σειρά.",
        "body_passed": "Τα ακίνητα σε μεταγενέστερη φάση περνούν τώρα αυτήν τη φάση. Ό,τι συνδέεται με αυτήν δημοσιεύεται αμέσως σε αυτά.",
        "body_passed_sup": "Αυτό το έργο περνά τώρα αυτήν τη φάση. Ό,τι συνδέεται με αυτήν δημοσιεύεται αμέσως.",
        "body_passes": "Τα ακίνητα σε αυτήν τη φάση περνούν τώρα τις ενδιάμεσες φάσεις. Ό,τι συνδέεται με αυτές τις φάσεις δημοσιεύεται αμέσως σε αυτά.",
        "body_passes_sup": "Αυτό το έργο περνά τώρα τις ενδιάμεσες φάσεις. Ό,τι συνδέεται με αυτές τις φάσεις δημοσιεύεται αμέσως.",
        "confirm": "Μετακίνηση φάσης",
        "count": "{count} ακίνητο περνά {phases} μονομιάς | {count} ακίνητα περνούν {phases} μονομιάς",
        "count_sup": "Αυτό το έργο περνά {phases} μονομιάς",
        "crossed": "{name} ({elements})",
        "nothing": "τίποτα",
        "phases": "{count} φάση | {count} φάσεις",
        "title": "Τοποθέτηση της φάσης «{name}» μετά το «{previous}»;",
        "title_first": "Τοποθέτηση της φάσης «{name}» πρώτη;"
      },
      "toasts": {
        "bulk_assigned": "Η φάση ανατέθηκε με επιτυχία στα επιλεγμένα ακίνητα",
        "create_success": "Η φάση δημιουργήθηκε με επιτυχία",
        "deleted": "Η φάση διαγράφηκε",
        "phase_without_units": "Δεν υπάρχουν πλέον ακίνητα σε αυτή τη φάση",
        "sup_assigned": "Η φάση ενεργοποιήθηκε με επιτυχία",
        "sup_completed": "Η φάση ολοκληρώθηκε",
        "units_completed": "{count} ακίνητο ολοκληρώθηκε | {count} ακίνητα ολοκληρώθηκαν",
        "units_moved": "{count} ακίνητο μετακινήθηκε | {count} ακίνητα μετακινήθηκαν",
        "update_success": "Οι φάσεις ενημερώθηκαν με επιτυχία"
      },
      "validation": {
        "needName": "Απαιτείται όνομα",
        "needNamePrimary": "Απαιτείται όνομα στην κύρια γλώσσα ({language})"
      }
    }
  }
}
